export const DialogOverrideStyle = {
    header: 'text-xl font-semibold text-foreground mb-4',
    footerContainer: 'border-t-0 bg-background',
};

export const AlertDialogOverrideStyle = {
    content: 'rounded-2xl p-8 !max-w-lg',
    header: 'gap-6 !grid-rows-[auto_auto_1fr] sm:!place-items-center sm:!text-center',
    media: 'size-auto rounded-full mb-0',
    title: 'text-2xl font-semibold text-foreground text-center sm:!col-auto',
    description: 'text-muted-foreground text-center text-base',
    footer: 'border-t-0 bg-background px-4 pb-4 gap-4 flex-row justify-end',
    highlightBox: 'rounded-lg py-4 px-6',
} as const;

export const LabelOverrideStyle = 'text-sm font-medium text-foreground';

export const InputOverrideStyle =
    'h-auto min-h-10 px-3 py-2 border-input focus-visible:ring-0.5 focus-visible:ring-brand';
